var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.6,
    height: 44.2,
    viewBox: "0 0 36.6 44.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m36.6,44.2H0v-8.9L13.9,0h8.7l14,35.3s0,8.9,0,8.9Zm-20.4-23.8l-4.7,11.8c-.5,1.2.1,2.5,1.3,2.9.3.1.5.2.8.2h9.4c1.2,0,2.3-1,2.3-2.3,0-.3-.1-.6-.2-.8l-4.7-11.8c-.5-1.2-1.8-1.7-2.9-1.3-.6.3-1.1.7-1.3,1.3",
    fill: "#353535",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDk);
export default __webpack_public_path__ + "static/media/icon-dk.237f648f319f60340487ae23470f7f58.svg";
export { ForwardRef as ReactComponent };